import React from 'react'
import CommunityPostsListing from './CommunityPostsListing'

const CommunityRankingUpdates = () => (
  <CommunityPostsListing
    postType="ranking_update"
    title="Ranking Update Posts"
    subtitle="Leaderboard movement shared with your community."
  />
)

export default CommunityRankingUpdates
